import { parseISO } from "date-fns";
import i18next from "i18next";

interface FormatDateOptions {
  format?: "date" | "short-date" | "datetime";
  formatOptions?: Intl.DateTimeFormatOptions;
}

export function formatISODate(
  dateString: string,
  options: FormatDateOptions = {}
): string {
  const { format = "date", formatOptions = {} } = options;
  const date = parseISO(dateString);

  const defaultOptions: Intl.DateTimeFormatOptions = {
    day: "2-digit",
    month: "short",
    ...formatOptions,
  };

  if (format === "short-date") {
    return date.toLocaleDateString(i18next.language, defaultOptions);
  }

  return format === "date"
    ? date.toLocaleDateString(i18next.language, {
        ...defaultOptions,
        year: "numeric",
      })
    : date.toLocaleString(i18next.language, {
        ...defaultOptions,
        year: "numeric",
        hour: "numeric",
        minute: "numeric",
      });
}
